// TYPES
import type { FailedResponse, SuccessResponse } from '..'

// UTILITIES
import { generateHeaders, createResponseObj } from '..'
import { vcBaseUrl } from '.'


type RemovePledgeResponse = SuccessResponse | FailedResponse

export class RemovePledgeRequest extends Request {
    private constructor(groupId: string, pledgeId: string, init?: RequestInit) { super(`${vcBaseUrl}/group/${groupId}/pledge/${pledgeId}`, init) }
    static async init(groupId: string, pledgeId: string, init?: RequestInit) {
        // The generateHeaders method sets the Content-Type header to `application/json` by default.
        // That header isn't supported with DELETE requests and has to be removed.
        const headers = await generateHeaders("Clerk-Token", init?.headers)
        headers.delete('Content-Type')
        return new RemovePledgeRequest(groupId, pledgeId, {
            ...init,
            method: 'DELETE',
            headers: headers,
        })
    }

    static async fetch(...args: Parameters<typeof this.init>) {
        const request = await this.init(...args)
        return await request.fetch()
    }

    public async fetch(): Promise<void> {
        const response = await fetch(this)
        const data = createResponseObj<RemovePledgeResponse>(await response.json())
        console.info("Remove Pledge Results:", data)

        switch (data.status) {
            case 'successful': return
            case 'failed': throw data
            default: throw new Error(`Unsupported Status: ${data}`)
        }
    }
}